<div class="row " style="padding-top: 75px;">
    <div class="col-sm-4 d-none d-lg-block">
        <div class="image-right d-none d-lg-block">
            <img src="assets/img/image.png" class="rounded img-fluid" alt="Cinque Terre">
        </div>
    </div>
    <div class="col-sm-8">
        <div *ngIf="showForm" style="
margin-top: 44px;
padding:30px;
padding-left: 40px;
padding-right: 40px;
max-width: 93.5%;
">
            <h2 class="text-register forminlinemargin" style="
    color: #000;
    font-weight: 640;
    padding-right: 0px;
    padding-bottom: 24px;
    padding-left: 0px;
    font-size: 32px;
    opacity: 0.87;
    margin: 0;
    line-height: 1.1;
  ">Registrasi Pelanggan</h2>
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link active" data-toggle="tab" href="#shipto">By Shipto</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-toggle="tab" href="#billto">By Billto</a>
                </li>
            </ul>
            <br>
            <div class="tab-content">
                <div class="tab-pane active" id="shipto">
                    <form [formGroup]="registerForm" (ngSubmit)="submitForm()">

                        <div class="row">

                            <input type="hidden" class="form-control forminlinemargin" placeholder="idRequest"
                                name="idRequest" readonly formControlName="idRequest">
                            <div class="form-group col-xs-4 col-md-4">
                                <input type="text" class="form-control forminlinemargin" placeholder="Outlet"
                                    name="outletName" readonly formControlName="outletName">
                            </div>
                            <div class="form-group col-xs-4 col-md-4">
                                <input type="email" class="form-control forminlinemargin" placeholder="PIC Email"
                                    name="emailCustomer" readonly formControlName="emailCustomer">
                            </div>
                            <div class="form-group col-xs-4 col-md-4">
                                <input list="shipTo" (keyup)="searchByShipto($event)" [(ngModel)]="searchInputSoldTo"
                                    type="text" (change)="onShiptoChanged(searchInputSoldTo)"
                                    class="form-control forminlinemargin" placeholder="Ship to" name="shipTo"
                                    formControlName="shipTo"
                                    [ngClass]="{ 'is-invalid': f.shipTo.touched && f.shipTo.errors }">
                                <div *ngIf="f.shipTo.touched && f.shipTo.errors"
                                    class="invalid-feedback forminlinemargin">
                                    <div *ngIf="f.shipTo.touched && f.shipTo.errors">*Ship to is required</div>
                                </div>
                                <datalist id="shipTo">
                                    <option *ngFor="let cust of searchResult" [ngValue]="cust.name">{{cust.shipTo}}
                                    </option>
                                </datalist>
                            </div>


                        </div>
                        <div class="row">
                            <div class="form-group col-xs-6 col-md-6">
                                <input type="text" class="form-control forminlinemargin" placeholder="PIC Name"
                                    name="picName" readonly formControlName="picName">
                            </div>
                            <div class="form-group col-xs-6 col-md-6">
                                <input type="text" class="form-control forminlinemargin" placeholder="Sales Name"
                                    name="emailSales" readonly formControlName="emailSales">
                            </div>
                        </div>


                        <p class="text-register">Customer Information</p>
                        <div class="row">
                            <div class="col-sm-6">

                                <div class="form-group">
                                    <label for="billToName">Bill To Name :</label>
                                    <input type="text" class="form-control" placeholder="Bill To Name" name="billToName"
                                        formControlName="billToName" readonly>
                                </div>




                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label for="soldtoname">Sold To Name :</label>
                                    <input type="text" class="form-control" placeholder="Sold to Name" name="soldtoname"
                                        formControlName="soldToName" readonly>
                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="address">Address :</label>
                                    <textarea type="text" class="form-control" placeholder="Alamat" name="address"
                                        formControlName="address" readonly></textarea>
                                </div>
                                <div class="form-group">




                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <label style="font-size: 0.7rem;">*Dengan melanjutkan kelangkah berikutnya, anda menyetujui semua
                                    <a [routerLink]="['/syarat&ketentuan']">syarat & ketentuan</a> serta
                                    <a [routerLink]="['/kebijakan-privasi']"> kebijakan privasi</a> yang berlaku

                                </label>
                            </div>
                            <div class="col-sm-6">
                                <button type="submit" class="btn btn-primary btn-block">Submit</button>
                            </div>
                            

                        </div>

                    </form>
                </div>
                <div class="tab-pane fade" id="billto">
                    <form [formGroup]="registerForm" (ngSubmit)="submitForm()">
                        <div class="row">
                            <input type="hidden" class="form-control forminlinemargin" placeholder="idRequest"
                                name="idRequest" readonly formControlName="idRequest">
                            <div class="form-group col-xs-4 col-md-4">
                                <input type="text" class="form-control forminlinemargin" placeholder="Outlet"
                                    name="outletName" readonly formControlName="outletName">
                            </div>
                            <div class="form-group col-xs-4 col-md-4">
                                <input type="email" class="form-control forminlinemargin" placeholder="PIC Email"
                                    name="emailCustomer" readonly formControlName="emailCustomer">
                            </div>
                            <div class="form-group col-xs-4 col-md-4">
                                <input list="billTo" (keyup)="searchByBillto($event)" [(ngModel)]="searchInputBillTo"
                                    (change)="onBilltoChanged(searchInputBillTo)" type="text"
                                    class="form-control forminlinemargin" placeholder="Bill to" name="billTo"
                                    formControlName="billTo"
                                    [ngClass]="{ 'is-invalid': f.billTo.touched && f.billTo.errors }">
                                <div *ngIf="f.billTo.touched && f.billTo.errors"
                                    class="invalid-feedback forminlinemargin">
                                    <div *ngIf="f.billTo.touched && f.billTo.errors">*Bill to is required</div>
                                </div>
                                <datalist id="billTo">
                                    <option *ngFor="let cust of searchListCustomerBillTo" [ngValue]="cust.id">
                                        {{cust.id}}
                                    </option>
                                </datalist>
                            </div>
                            <div class="form-group col-xs-6 col-md-6">
                                <input type="text" class="form-control forminlinemargin" placeholder="PIC Name"
                                    name="picName" readonly formControlName="picName">
                            </div>
                            <div class="form-group col-xs-6 col-md-6">
                                <input type="text" class="form-control forminlinemargin" placeholder="Sales Name"
                                    name="emailSales" readonly formControlName="emailSales">
                            </div>
                        </div>

                        <label class="text-register">Customer Information</label>
                        <div class="form-group">
                            <input type="text" class="form-control" placeholder="Bill To Name" name="billtoname"
                                readonly formControlName="billToName">
                        </div>


                    </form>
                    <table class="table table-borderless dt-responsive nowrap" id="table">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Customer Name</th>
                                <th>Address</th>
                                <th><input type="checkbox" [(ngModel)]="masterSelected" name="list_name" value="m1"
                                        (change)="checkUncheckAll()"><strong>Select All</strong></th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let x of searchResultBillToPage; let y=index">
                            <tr>
                                <td>{{y+1}}</td>
                                <td>{{x.shipToName}}</td>
                                <td>{{x.address}}</td>
                                <td><input type="checkbox" [(ngModel)]="x.isSelected" name="list_name"
                                        value="{{x.shipTo}}" (change)="isAllSelected()"></td>
                        </tbody>
                    </table>
                    <div class="form-group">
                        <!-- <div class="col-md-6">
                        <code>{{checkedList}}</code>
                    </div> -->

                        <div class="row">
                            <div class="col-sm-6">
                                <label style="font-size: 0.7rem;">*Dengan melanjutkan kelangkah berikutnya, anda menyetujui semua
                                    <a href="url">syarat & ketentuan</a> serta
                                    <a href="url"> kebijakan privasi</a> yang berlaku
                                </label>
                            </div>
                            <div class="col-sm-6">
                                <button type="button" (click)="submitFormBillTo()"
                                    class="btn btn-primary btn-block">Submit</button>
                            </div>
                           

                        </div>

                    </div>

                </div>
            </div>
        </div>

    </div>



</div>
<div *ngIf="showWarning" class="container border roundcorner" style="
margin-top: 100px;
padding:30px;
padding-left: 40px;
padding-right: 40px;
max-width: 93.5%;
">
    <p class="text-center" [textContent]="textWarning"></p>
</div>